import { Page } from '@app/components/page/Page';
import { UserIcon } from '@app/components/users/UserIcon';
import { ListViewLocal } from '@app/core/list-view/ListViewLocal';
import { fetchUsers } from '@app/modules/admin/api';
import { AddButton } from '@app/modules/admin/components/AddButton';
import { User } from '@mi-front/core';
import { useIntl } from 'react-intl';
import { ADMIN_USERS_FILTERS_CONFIG } from './filters/admin-users-filters-config';
import { UsersList } from './UsersList';

/**
 * Loads all users once and filters locally via ListViewLocal toolbar.
 */
export function ListUsersPage() {
  const { $t } = useIntl();
  const title = $t({
    id: 'admin.users.listScreen.title',
    defaultMessage: 'Administrar usuarios',
  });

  const queryFn = async (): Promise<User[]> => {
    const response = await fetchUsers({
      page: 0,
      pageSize: 9999,
    });
    return response.results;
  };

  return (
    <Page data-cy="users-list-screen" htmlTitle={title}>
      <Page.Header
        icon={<UserIcon />}
        title={title}
        actions={
          <AddButton
            to="/admin/users/add"
            label={$t({
              id: 'admin.users.listScreen.links.createUser',
              defaultMessage: 'Crear usuario',
            })}
          />
        }
      />
      <ListViewLocal
        listId="admin-users"
        filters={ADMIN_USERS_FILTERS_CONFIG}
        queryFn={queryFn}
        ListComponent={UsersList}
        ListWrapper={Page.Content}
        enablePagination={false}
        showProgress
      />
    </Page>
  );
}
